
import { useEffect } from 'react';
import ModalHeader from './ModalHeader';
import AuthTabs from './AuthTabs';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSignInSuccess: () => void;
  onSignUpSuccess: () => void;
}

const AuthModal = ({ isOpen, onClose, onSignInSuccess, onSignUpSuccess }: AuthModalProps) => {
  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    
    window.addEventListener('keydown', handleEscapeKey);
    return () => window.removeEventListener('keydown', handleEscapeKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="glass-card rounded-lg p-6 max-w-md w-full animate-fade-in">
        <ModalHeader onClose={onClose} />
        <AuthTabs onSignInSuccess={onSignInSuccess} onSignUpSuccess={onSignUpSuccess} onCancel={onClose} />
      </div>
    </div>
  );
};

export default AuthModal;
